"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isExternalChatUser(object) {
    return checkExternalChatUser(object).fulfilled;
}
exports.isExternalChatUser = isExternalChatUser;
function checkExternalChatUser(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasChoice("type", ["internal", "external"]), __1.hasString("externalId").optional(), __1.hasString("internalId").optional(), __1.hasString("name")).withOptions(options).explain();
}
exports.checkExternalChatUser = checkExternalChatUser;
//# sourceMappingURL=ExternalChatUser.js.map